import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  exportFormat: yup.string().label("exportFormat").oneOf(["pdf", "excel"]),
  startDate: yup.string().required("Start date is required"),
  endDate: yup.string().required("End date is required"),
  selectedStores: yup.array().nullable(),
  transactionType: yup.string().nullable(),
});

const Validation = (
  exportFormat,
  startDate,
  endDate,
  selectedStores,
  transactionType,
) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      exportFormat,
      startDate,
      endDate,
      selectedStores,
      transactionType,
    },
  });
};

export default Validation;
